// extracted by mini-css-extract-plugin
export default {"passInput":"Pass_passInput__BLMRx","passButton":"Pass_passButton__-y6a3"};